import { useState } from "react";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    try {
      const res = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (res.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (err) {
      console.error(err);
      setStatus("error");
    }
  };

  const inputClass =
    "w-full bg-white/5 border border-white/15 rounded-xl px-4 py-3 text-white placeholder:text-white/40 focus:border-cyan-400/50 focus:outline-none transition";

  return (
    <form onSubmit={handleSubmit} className="w-full space-y-4">
      <input
        type="text"
        name="name"
        placeholder="Ваше имя"
        value={formData.name}
        onChange={handleChange}
        required
        className={inputClass}
      />
      <input
        type="email"
        name="email"
        placeholder="Ваш Email"
        value={formData.email}
        onChange={handleChange}
        required
        className={inputClass}
      />
      <textarea
        name="message"
        placeholder="Сообщение"
        value={formData.message}
        onChange={handleChange}
        required
        rows={4}
        className={`${inputClass} resize-none`}
      ></textarea>
      <button
        type="submit"
        disabled={status === "loading"}
        className="font-display btn-primary w-full justify-center disabled:opacity-60"
      >
        Отправить
      </button>

      {status === "success" && (
        <p className="text-sm text-lime-400">Сообщение отправлено!</p>
      )}
      {status === "loading" && <p className="text-sm text-white/50">Отправка...</p>}
      {status === "error" && (
        <p className="text-sm text-red-400">
          Не удалось отправить сообщение. Попробуйте позже или напишите на info@askommet.kz
        </p>
      )}
    </form>
  );
}
